import React from 'react';

const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32px" height="32px">
    <path
      fill="#e75953"
      d="M8.71 21.5a1.52 1.52 0 0 1-1.06-.44L3 16.39a1.48 1.48 0 0 1-.44-1.06V8.72A1.52 1.52 0 0 1 3 7.65L7.61 3a1.5 1.5 0 0 1 1.06-.44h6.61a1.52 1.52 0 0 1 1.07.44L21 7.61a1.5 1.5 0 0 1 .44 1.06v6.61a1.52 1.52 0 0 1-.44 1.07L16.39 21a1.48 1.48 0 0 1-1.06.44H8.72z"
    />
    <path
      fill="#963a37"
      d="M15.29 3a1 1 0 0 1 .71.29L20.69 8a1 1 0 0 1 .29.71v6.62a1.05 1.05 0 0 1-.29.71L16 20.69a1 1 0 0 1-.71.29L8.71 21a1.05 1.05 0 0 1-.71-.29L3.31 16a1 1 0 0 1-.31-.67V8.71A1.05 1.05 0 0 1 3.29 8L8 3.31A1 1 0 0 1 8.67 3h6.62m0-1H8.67a2 2 0 0 0-1.42.59L2.59 7.3A2 2 0 0 0 2 8.72v6.61a2 2 0 0 0 .59 1.42l4.71 4.66a2 2 0 0 0 1.41.59h6.61a2 2 0 0 0 1.42-.59l4.66-4.69a2 2 0 0 0 .6-1.44V8.67a2 2 0 0 0-.59-1.42L16.7 2.59A2 2 0 0 0 15.29 2z"
    />
    <circle fill="#fff" cx="12" cy="16" r="1" />
    <path fill="#fff" d="M13 13a1 1 0 0 1-2 0V8a1 1 0 0 1 2 0z" />
  </svg>
);

export default ErrorIcon;
